(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.controller('AgendaListsStatesController', ['$scope', '$filter', '$timeout', 'SharedAgendaService', 'AppointmentState', '$rootScope', 'AgendaFilterBroadcast', 'AgendaOverviewService', AgendaListsStatesControllerFn]);

    /* controller for agenda list - states */
    function AgendaListsStatesControllerFn($scope, $filter, $timeout, SharedAgendaService, AppointmentState, $rootScope, AgendaFilterBroadcast, AgendaOverviewService) {
        var vm = this;

        // list of appointment-states
        vm.appointmentStates = [];
        vm.selectedAppointmentStates = [];
        
        vm.isPaid = null;
        vm.isVideoconsult = null;
        vm.filterDates = {
            startDate: null,
            endDate: null
        };

        // current agenda 
        vm.agenda = null;

        // show list
        vm.show = false;

        activate();

        // reload appointments 
        vm.reload = function () {
            selectFilter();
        };

        // clear filter 
        vm.clear = clear;

        /* activation work */
        function activate() {
            // allow shared agenda-switch
            SharedAgendaService.allow();

            // current agenda
            vm.agenda = SharedAgendaService.data.currentAgenda;

            // load appointment-state filter data
            vm.appointmentStates.push(AppointmentState.None);
            vm.appointmentStates.push(AppointmentState.Present);
            vm.appointmentStates.push(AppointmentState.Urgent);
            vm.appointmentStates.push(AppointmentState.FollowUp);
            vm.appointmentStates.push(AppointmentState.NoShow);
            vm.appointmentStates.push(AppointmentState.Finished);

            // set default filter 
            clear(true); // load filter from localstorage

            
            // show
            vm.show = true;
        }       

        // select the filter 
        function selectFilter() {
            $timeout(function () {
                vm.show = false;
            });

            // get selected appointmentstates
            vm.selectedAppointmentStates = [];
            //  vm.filteredStates = [];
            if (vm.appointmentStates) {
                for (var i = 0; i < vm.appointmentStates.length; i++) {
                    if (vm.appointmentStates[i].vmSelected === true) {
                        vm.selectedAppointmentStates.push(vm.appointmentStates[i].value);
                    }
                }
            }

            $timeout(function () {
                vm.show = true;
            });

        }

        function clear(loadFromLocalStorage) {
            vm.show = false;
            vm.isPaid = null;
            vm.isVideoconsult = null;
            vm.filterDates ={
                startDate: null,
                endDate: null
            };
            // unselect all states by default
            for (var i = 0; i < vm.appointmentStates.length; i++) {
                vm.appointmentStates[i].vmSelected = false;
            }
            // inform listener
            $rootScope.$broadcast(AgendaFilterBroadcast.AppointmentStateRefresh);
            $rootScope.$broadcast(AgendaFilterBroadcast.AppointmentStateClear);
        }
    }
})();